import api from './client';

// Cleaning actuals from management statements (read-only)
export const cleaningActualsAPI = {
  get: async ({ entity_id, year }) => {
    const res = await api.get('/admin/cost/cleaning-actuals', {
      params: { entity_id, year },
    });
    return res.data;
  },
};

export const commissionActualsAPI = {
  get: async ({ entity_id, year }) => {
    const res = await api.get('/admin/cost/commission-actuals', {
      params: { entity_id, year },
    });
    return res.data;
  },
};

// Management Statements API
export const managementStatementsAPI = {
  getAll: (params) => api.get('/management-statements', { params }),
  get: (id) => api.get(`/management-statements/${id}`),
  upload: (file, entityId) => {
    const formData = new FormData();
    formData.append('file', file);
    if (entityId) formData.append('entity_id', entityId);
    return api.post('/management-statements/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  delete: (id) => api.delete(`/management-statements/${id}`),
  // Admin-only, genuine irreversible delete (contrast with delete() above,
  // which always soft-excludes). Refuses with 409 while any
  // statement_payout_matches doc or transaction still references the id.
  hardDelete: (id) => api.delete(`/admin/management-statements/${id}/hard-delete`),
  reconcile: (id) => api.post(`/management-statements/${id}/reconcile`),
  downloadAttachment: (id) => api.get(`/management-statements/${id}/attachment`, { responseType: 'blob' }),
  scanGmail: ({ forceRescan = false } = {}) => api.post('/management-statements/scan-gmail', null, { params: { force_rescan: forceRescan } }),
  scanProgress: () => api.get('/management-statements/scan-progress'),
  scanDiagnostics: () => api.get('/management-statements/scan-diagnostics'),
  // Visible, persistent parse-failure queue (Commit 2) -- read-only, never
  // a duplicate of getAll(); a record here exists ONLY when no statement
  // doc could be built at all (no_pdf / fetch_error / parse_error /
  // stale_location).
  getParseFailures: () => api.get('/management-statements/parse-failures'),
};
